import { toSizeName } from "core/helpers";

import type { Size, SizeAdapted } from "~/common/interfaces/entities/size.interface";

export const sizeDenormalize = (size: SizeAdapted): Size => {
	const { name: _name, ...rest } = size;

	return rest;
};

export const sizeNormalize = (size: Size): SizeAdapted => {
	const { width, height, length, ...rest } = size;

	return {
		...rest,
		name: toSizeName({ width, height, length }),
		width,
		height,
		length
	};
};
